import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {rootRouterConfig} from './app.routes';
import {AngularFireModule} from '@angular/fire';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {environment} from '../environments/environment';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {RegisterComponent} from './register/register.component';
import {UserResolver} from './dashboard/user.resolver';
import {AuthGuard} from './core/auth.guard';
import {AuthService} from './core/auth.service';
import {UserService} from './core/user.service';
import {ReactiveFormsModule} from '@angular/forms';
import {FormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {AngularDateTimePickerModule} from 'angular2-datetimepicker';
import {HttpClientModule} from '@angular/common/http';
import {DocumentService} from './document.service';
import {OpenRequestsComponent} from './open-requests/open-requests.component';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {LoadingSpinnerComponent} from './loading-spinner/loading-spinner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule, BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { AdminControlsComponent } from './admin-controls/admin-controls.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    RegisterComponent,
    OpenRequestsComponent,
    LoadingSpinnerComponent,
    AdminControlsComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AngularDateTimePickerModule,
    RouterModule.forRoot(rootRouterConfig, {useHash: false}),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot()
  ],
  providers: [AuthService, UserService, UserResolver, AuthGuard, DocumentService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
